
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElDatePicker,
} from "element-plus";

// Models
import {AppCommonDiagnosticCategory} from "@/models/app/common/diagnostic-category";

@Options({
  props: [
    "diagnosticCategories",
  ],
  components: {
    ElRow,
    ElCol,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElDatePicker,
  },
})
export default class AdministratorPlayersProfileDiagnosticsFilterIndexVue extends Vue {
  diagnosticCategories: Array<AppCommonDiagnosticCategory> = [];

  formData: any = {
    filter: {
      user_id: "*",
      diagnostic_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  getDiagnosticsByFilter(): void {
    this.$emit("getDiagnosticsByFilter", this.formData);
  }

  created(): void {
    this.formData.filter.user_id = this.$route.params.id;
  }
}
